import { RouteConfig } from 'vue-router';
import registerChildRoutes from '../routes-children/register';
import localizationFactory from "@/router/modules/localization-factory";

export default {
  name: '',
  path: '/register-operation',
  component: () => import('../../views/Register/Index.vue'),
  meta: localizationFactory('home.payment.register', {
    layout: 'main',
  }),
  children: registerChildRoutes
} as RouteConfig;
